import './App.css';
import Aux from './hoc/AuxWrapper';
import AllRoutes from './routes';
import 'bootstrap/dist/css/bootstrap.min.css';
import { strings } from './localization/Localization';
import { AuthProvider } from './pages/Auth/AuthContext';

function App() {

  const activeLanguage= localStorage.getItem('activeLanguage')
  if(activeLanguage === null || activeLanguage === undefined){
    localStorage.setItem('activeLanguage', 'mk')
    strings.setLanguage('mk')
  } else {
    strings.setLanguage(activeLanguage)
  }

  return (
    <Aux>
      <AuthProvider>
        <AllRoutes />
      </AuthProvider>
    </Aux>
  );
}

export default App;
